/// Appelé uniquement sur la page de coordonnees des listes mariages, pacs et cadeaux
/// /liste-cadeaux/creation-liste-[TypeList]
class Coordonnees extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize(idFormulaire) {
		let self = this;

		super.initialize();

		const form = new Formulaire(settings);
		form.initialize(idFormulaire);

		/// On retire la value si elle vaut 0
		document.addEventListener('DOMContentLoaded', function () {
			document.getElementById('montant').value === '0' && document.getElementById('montant').removeAttribute('value');
		});

		/// Bénéficiaire 1
		/// On change l'indicatif téléphonique si le pays change
		document.getElementById('CoordonneesVM_Pays1').addEventListener('change', function (el) {
			form.indicatifTelephonique(true, el.target.value)
		});
		//this.complementTel('telfixe', 'toggletelfixe');
		form.dqe(idFormulaire, this.config.dqeObj, ['CoordonneesVM_CodePostal1', 'CoordonneesVM_Ville1']);


		if (settings.liste === 'C') {
			/// Organisateur 3
			//this.complementTel('telfixe3', 'toggletelfixe3');
			form.dqe(idFormulaire, this.config.dqeObj3, ['CoordonneesVM_CodePostal3', 'CoordonneesVM_Ville3']);
			!settings.beneficiaire && this.beneficiaire(settings.urlBeneficiaire, idFormulaire);
			document.getElementById('CoordonneesVM_Pays3').addEventListener('change', function (el) {
				form.indicatifTelephonique(true, el.target.value)
			});
		} else {
			/// Bénéficiaire 2
			//this.complementTel('telfixe2', 'toggletelfixe2');
			form.dqe(idFormulaire, this.config.dqeObj2, ['CoordonneesVM_CodePostal2', 'CoordonneesVM_Ville2']);
			document.getElementById('CoordonneesVM_Pays2').addEventListener('change', function (el) {
				form.indicatifTelephonique(true, el.target.value)
			});
		}

		/// Fonction permettant d'ajouter un email à la liste des personnes à informer en cas de virement
		this.emailInfo();

		/// Indicatif téléphonique
		form.indicatifTelephonique();

	}
	emailInfo(emailInput) {

		let fieldsEmail = [];

		if (document.getElementById(emailInput) === null) {
			fieldsEmail = document.querySelectorAll('[type="email"]');
		} else {
			fieldsEmail.push(document.getElementById(emailInput));
		}

		for (let email of fieldsEmail) {
			if (email.value != '') {
				let id = email.id;
				let arr = id.split('_');
				let label = document.getElementById(`selection_${arr[1]}`);
				label.innerText = email.value;
				label.parentElement.hidden = false;
			}
			email.addEventListener('change', function (el) {
				let value = el.target.value;
				let id = el.target.id;
				let arr = id.split('_');
				let label = document.getElementById(`selection_${arr[1]}`);
				label.innerText = value;
				label.parentElement.hidden = false;
			})
		}
	}

	complementTel(idFixe, idToggle) {
		let checkTelFix = document.getElementById(idFixe);
		checkTelFix.addEventListener('change', function (el) {
			document.getElementById(idToggle).checked = el.target.checked;
		})
	}

	beneficiaire(url, idForm) {
		let self = this;
		document.getElementById('ajoutbeneficiaire').addEventListener('click', function () {
			try {
				fetch(url, {
						method: 'GET'
					})
					.then((resp) => {
						return resp.text();
					})
					.then((html) => {
						// On met le html en cache @todo tester si existe avant fetch
						document.getElementById('beneficiaire').innerHTML = html;
						document.getElementById('ajoutbeneficiaire').hidden = true;
						document.getElementById('suprimebeneficiaire').hidden = false;
						const form = new Formulaire(settings);
						//self.complementTel('telfixe2', 'toggletelfixe2');
						form.dqe(idForm, self.config.dqeObj2, ['CoordonneesVM_CodePostal2', 'CoordonneesVM_Ville2']);
						self.emailInfo('CoordonneesVM_Email2');
						document.getElementById('hiddenbeneficiaire2').value = 1;
						document.dispatchEvent(
							new CustomEvent("dqe:add-instance", {
								detail: {
									configDqe: self.config.dqeObj2
								},
							}),
						);
						form.initialize("CoordonneesListeCadeaux");
						return true;
					});
			} catch (e) {
				console.error(e)
			}
		});
		document.getElementById('suprimebeneficiaire').addEventListener('click', function () {
			document.getElementById('beneficiaire').innerHTML = '';
			document.getElementById('ajoutbeneficiaire').hidden = false;
			document.getElementById('suprimebeneficiaire').hidden = true;
			document.getElementById('hiddenbeneficiaire2').value = 0;
		});
	}
}